import { PhosphorRefreshButton } from "components/Atoms/PhosphorIconButton";
import RequiredNumberInput from "components/ValidatedFields/RequiredNumberInput";
import React from "react";

interface ExchangeRateInputProps {
  value: number
  onChange: (newValue: number) => void
  validatorKey: string
  currency: server.dto.Currencies
  onExchangeRateRefresh: () => void
  loading: boolean
  onEsc: () => void
  onEnter: (newValue: number) => void
}

export const ExchangeRateInput = (props: ExchangeRateInputProps) => {
  const currency = serverReference.currencies.find((c) => c.value === props.currency);

  return <div className="flex gap align-center">
    <RequiredNumberInput
      width={120}
      loading={props.loading}
      canBeNegative={false}
      labelContent={currency.text}
      decimalPoints={6}
      validatorKey={props.validatorKey}
      value={props.value}
      onChange={props.onChange}
      onEscPressed={props.onEsc}
      onEnterPressed={props.onEnter}
    />
    <PhosphorRefreshButton
      iconSize="large"
      disabled={props.loading}
      layout="in-square"
      selectedStyle="green-bg"
      onClick={props.onExchangeRateRefresh}
    />
  </div>
}